function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.85979 0.888074L9.16901 0.205506C8.98209 0.0185904 8.67328 0.0185904 8.47824 0.205506L5.03248 3.65118L1.5218 0.140492C1.3348 -0.0465051 1.02598 -0.0465051 0.831023 0.140492L0.140248 0.831268C-0.0467493 1.01818 -0.0467493 1.327 0.140248 1.52204L3.64289 5.02468L0.205262 8.47856C0.0183462 8.66548 0.0183462 8.9743 0.205262 9.16934L0.896038 9.86012C1.08295 10.047 1.39177 10.047 1.58681 9.86012L5.03248 6.41436L8.47824 9.86012C8.66515 10.047 8.97397 10.047 9.16901 9.86012L9.85979 9.16934C10.0467 8.98242 10.0467 8.67361 9.85979 8.47856L6.40591 5.03281L9.85166 1.58714C10.0467 1.39193 10.0467 1.08312 9.85979 0.888074Z",
  fill: "#F13535"
});

var SvgRedCross = function SvgRedCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red-cross.2accd033.svg";
export { ForwardRef as ReactComponent };